import type { AreaCatalog } from '../area';
import type { push as en } from '../en/push';

export const push = {
  'push.title.untitled': 'Ohne Titel',
  'push.body.requesterWalkedAway': 'Die Aufgabe ist jetzt verwaist',
  'push.body.deliveryDenied': 'Abnahme verweigert',
  'push.body.needsAttention': 'Braucht deine Aufmerksamkeit',
  'push.body.act': 'Neu bei dieser Aufgabe: {act}',
  'push.body.decisionAwaits': 'Eine Entscheidung wartet auf dich',
  'push.body.actorOfferedSeat': '{actor} hat dir eine Aufgabe zugewiesen: {role}',
  'push.body.offeredSeat': 'Jemand hat dir eine Aufgabe zugewiesen: {role}',
  'push.body.actorNamedYou': '{actor} hat dich in {item} genannt',
  'push.body.namedYou': 'Jemand hat dich in {item} genannt',
  'push.follow.everyEvent': 'Benachrichtigt dich auch bei jedem Ereignis.',
  'push.follow.notices': 'Benachrichtigt dich auch bei Hinweisen und Wichtigerem.',
  'push.follow.warnings': 'Benachrichtigt dich auch bei Warnungen und Wichtigerem.',
  'push.follow.criticals': 'Benachrichtigt dich auch bei kritischen Ereignissen.',
} as const satisfies AreaCatalog<typeof en>;
